import { BasicModel } from './basic.model';
import { RiskLocation } from './risk-location.model';

export class AdditionalInsured extends BasicModel<AdditionalInsured> {
    firstName?: string;
    lastName?: string;
    taxId?: string;
    officialIdTypeCode?: string;
    contactTypeCode?: string;
    address?: RiskLocation;
    email?: string;
    phoneNumber?: string;
    mobileNumber?: string;
}
